export default {
  realmRemoved: 'Realm removed',
  realmUpdated: 'Realm updated',
  realmAdded: 'Realm added',
  realms: 'Realms'
}
